import script from "./NoStockModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoStockModal.vue?vue&type=script&lang=ts&setup=true"

import "./NoStockModal.vue?vue&type=style&index=0&id=4cab35ba&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cab35ba"]])

export default __exports__